export const emails = {
    support: 'sales@pocketlaw.com',
};
